import PropTypes from "prop-types";
import React from "react";
import Button from "../../../Button/Button";
import Update from "../../../../assets/assets/delete.svg";

const UploadKeys = (props) => {
  const {
    submitValues,
    state,
    showWidget,
    removeFile,
    isSubmitting,
    isUploadingKey,
    uploadSuccess,
  } = props;

  const block = state.public_key_url === "";

  return (
    <div className="nip-public-keys-bottom">
      <div className="nip-public-keys-bottom-upload">
        <div
          className={
            state.loaded && uploadSuccess
              ? "nip-file-uploaded"
              : "nip-file-input"
          }
        >
          {!state.loaded ? (
            <div className="label-file">
              <input
                type="file"
                className="custom-file-input"
                data-testid="showWidget"
                onChange={showWidget}
                accept=".key"
              />
            </div>
          ) : isUploadingKey ? (
            <div div className="uploaded-public2">
              <span>Uploading keys...</span>
            </div>
          ) : uploadSuccess ? (
            <div className="uploaded-public">
              <span>{state.public_key_url && state.public_key_url.name}</span>
              <div
                className="uploaded-public-icon"
                data-testid="removeFile"
                onClick={() => removeFile()}
              >
                <img src={Update} alt="update" />
              </div>
            </div>
          ) : (
            <div className="uploaded-public2">
              <span>Failed to upload keys</span>

              <span
                className="retry-upload"
                data-testid="retry-upload"
                onClick={() => removeFile()}
              >
                Retry
              </span>
            </div>
          )}
        </div>
        {state.error !== "" && block && <p className="errors">{state.error}</p>}
      </div>
      <div className="nip-public-keys-bottom-button">
        <Button
          className="button"
          type="submit"
          width="50%"
          height="50px"
          testId="submit"
          onClick={() => submitValues()}
          text={isSubmitting ? "SUBMITTING..." : "PROCEED"}
          disabled={block || isSubmitting || (state.loaded && !uploadSuccess)}
        />
      </div>
    </div>
  );
};

UploadKeys.propTypes = {
  isSubmitting: PropTypes.any,
  isUploadingKey: PropTypes.any,
  removeFile: PropTypes.func,
  showWidget: PropTypes.any,
  state: PropTypes.shape({
    error: PropTypes.string,
    img_url: PropTypes.string,
    loaded: PropTypes.any,
    public_key_url: PropTypes.shape({
      name: PropTypes.any,
    }),
  }),
  submitValues: PropTypes.func,
  uploadSuccess: PropTypes.any,
};

export default UploadKeys;
